import { renewals } from '@homevest/utils'

type PresentableRenewal = {
  created_at: string
  status: string
}

type PresentableSigner = {
  status: string
}

const { PENDING_RENEWAL_STATUSES, RENEWAL_STATUSES } = renewals

const newestFirst = <T extends PresentableRenewal>(left: T, right: T) =>
  new Date(right.created_at).getTime() - new Date(left.created_at).getTime()

export const groupRenewalsForDisplay = <T extends PresentableRenewal>(renewalList: T[]) => {
  const current = renewalList.filter((renewal) => renewal.status !== RENEWAL_STATUSES.CANCELED)
  const canceled = renewalList.filter((renewal) => renewal.status === RENEWAL_STATUSES.CANCELED)

  current.sort((left, right) => {
    const leftIsPending = (PENDING_RENEWAL_STATUSES as string[]).includes(left.status)
    const rightIsPending = (PENDING_RENEWAL_STATUSES as string[]).includes(right.status)
    if (leftIsPending !== rightIsPending) return leftIsPending ? -1 : 1
    return newestFirst(left, right)
  })

  canceled.sort(newestFirst)
  return { current, canceled }
}

export const summarizeSignerProgress = (signers: PresentableSigner[]) => {
  if (signers.length === 0) return 'No signers'

  const signedCount = signers.filter((signer) => signer.status === 'signed').length
  const canceledCount = signers.filter((signer) => signer.status === 'canceled').length

  if (signedCount === signers.length) return `All ${signers.length} signed`
  if (canceledCount === signers.length) return `All ${signers.length} canceled`
  return `${signedCount} of ${signers.length} signed`
}
